(() => {
  const loader = document.currentScript;
  const sectionId = loader?.dataset.sectionId;

  if (!sectionId) return;

  const productSection = Array.from(
    document.querySelectorAll('.sl-enhanced-product[data-section-id]')
  ).find((section) => section.dataset.sectionId === sectionId);

  const badgeText = productSection?.dataset.assortionAddonBadge?.trim();

  if (!productSection || !badgeText) return;

  // Mehrere Badges pro Produkt: "Match::Badge|Match::Badge".
  // Ohne "::" gilt der ganze Text unveraendert fuer alle Addon-Boxen.
  const rules = badgeText
    .split('|')
    .map((part) => {
      const idx = part.indexOf('::');
      return idx === -1
        ? { match: null, label: part.trim() }
        : { match: part.slice(0, idx).trim().toLowerCase(), label: part.slice(idx + 2).trim() };
    })
    .filter((rule) => rule.label);

  const badgeFor = (group) => {
    const text = group.textContent.toLowerCase();
    const rule = rules.find((r) => !r.match || text.includes(r.match));
    return rule ? rule.label : null;
  };

  const applyBadge = () => {
    productSection.querySelectorAll('.ast-addon-group').forEach((group) => {
      if (!group.querySelector('.ast-addon-item')) return;

      const label = badgeFor(group);
      if (!label) {
        group.classList.remove('tw-has-custom-badge');
        return;
      }

      group.classList.add('tw-has-custom-badge');
      group.dataset.assortionBadge = label;
    });
  };

  applyBadge();

  new MutationObserver(applyBadge).observe(productSection, {
    childList: true,
    subtree: true
  });
})();
